/*@flow*/

export const BLUE = 'rgba(17, 129, 251, 1)';
export const RED = '#f44336';
export const GRAY = '#a6b7c2';
export const GREEN = '#009688';
export const DEFAULT_STROKE_COLOR = '#EE7B2C';

